import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asah-syllabus',
  templateUrl: './asah-syllabus.component.html',
  styleUrls: ['./asah-syllabus.component.scss']
})
export class AsahSyllabusComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
